/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import DateRange from './DateRange'
import ReassignTable from './ReassignTable'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'
import { Button } from 'src/Common/ui/button'
import ApplyCancel from './ApplyCancel'
import ReRaci from './ReRaci'
import Acknowledge from './Acknowledge'
import { useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import Textarea from 'src/Common/ui/textArea'
import { useForm } from 'react-hook-form'
import { cn } from 'src/lib/utils'
import { t } from 'i18next'
import { TRANSFER_STATUS } from 'src/Entities/CommonEntities'

export default function ReassignDialog ({ isOpened, activeCalendarDate, data, viewType, handleCloseModal }) {
    const [ date, setDate ] = useState({
        from: null,
        to: null
    })
    const { control, formState: { errors }, handleSubmit } = useForm()
    const notificationId = useCompStore(state => state.notificationId)
    const { TransferComplianceDetail, AcknowledgeTransferComplianceDetails } = useCompStore()
    const [ matrixOptions, setMatrixOptions ] = useState({
        departmentOptions: [],
        department: null,
        roleOptions: [],
        role: null,
        userOptions: [],
        user: null
    })
    const [ selectAll, setSelectAll ] = useState(false)
    const [ disable, setDisable ] = useState(false)
    const [ noti, setNoti ] = useState(null)
    useEffect(() => {
        if (notificationId)setNoti(notificationId)
    }, [notificationId])
    const deptId = +localStorage.getItem('departmentId')
    useEffect(() => {
        setMatrixOptions(prevState => ({
            ...prevState, department: deptId
        }))
    }, [deptId])

    useEffect(() => {
        setType(viewType)
    }, [viewType])
    useEffect(() => {
        if (type === 'Acknowledge') setGetData(data)
    }, [data])
    useEffect(() => {
        if (matrixOptions.user) {
            setDisable(false)
        } else {
            setDisable(true)
        }
    }, [matrixOptions.user])
    const [ type, setType ] = useState(viewType)
    const [ getData, setGetData ] = useState()
    const handleDateChange = (e, key) => {
        setDate(prevState => ({
            ...prevState,
            [key]: e
        }))
    }
    useEffect(() => {
        if (getData?.some((ele) => ele.transferStatus === TRANSFER_STATUS.OWN && ele.checkbox)) {
            setSelectAll(true)
        } else {
            setSelectAll(false)
        }
    }, [getData])
    useEffect(() => {
        const dat = new Date(activeCalendarDate)
        const fromDat = new Date(activeCalendarDate)
        const fromDate = fromDat
        const toDate = dat.setMonth(dat.getMonth() + 1, 0)
        fromDate.setHours(0, 0, 0, 0)
        setDate(prevState => ({
            ...prevState,
            from: fromDate,
            to: toDate
        }))
    }, [activeCalendarDate])
    const handleSelectChecked = (id, selectAll, dueFor) => {
        setGetData(prevState => {
            return prevState.map((ele, index) => {
                if (id) {
                    if (ele.complianceId === id && ele.dueFor === dueFor) ele.checkbox = !ele.checkbox
                    setSelectAll(false)
                } else {
                    if (ele.transferStatus === 'own') {
                        ele.checkbox = selectAll
                    }
                }
                return ele
            })
        })
        if (!id) {
            setSelectAll(selectAll)
        }
    }
    const handleClose = () => {
        handleCloseModal()
        setType('Apply')
        setGetData([])

        setMatrixOptions(prevState => ({
            ...prevState,
            user: null,
            role: null
        }))
        setRemarks(null)
    }
    const handleDateApply = () => {
        setGetData(data.map((item) => {
            if (new Date(item.dueBy) >= new Date(date.from) && new Date(item.dueBy) <= new Date(date.to) && item.complianceId !== null) {
                item.checkbox = false
                return item
            }
            return null
        }).filter(el => el))
    }
    const userId = localStorage.getItem('userId')
    const orgId = localStorage.getItem('orgId')
    const handleAcknowledege = () => {
        AcknowledgeTransferComplianceDetails(noti, userId)
        handleCloseModal()
    }
    const onSubmit = async () => {
        const final = {
            fromUser: userId,
            toUser: matrixOptions.user,
            complianceList: getData.filter(ele => ele.checkbox).map((ele) => ({
                orgId,
                complianceId: ele.complianceId,
                dueFor: ele.dueForT,
                dueBy: ele.dueByT,
                modifiedDueBy: ele.modifiedDueBy
            }))

        }
        await TransferComplianceDetail(final)
        setGetData([])

        setMatrixOptions(prevState => ({
            ...prevState,
            user: null,
            role: null
        }))
        setRemarks(null)
        handleCloseModal()
    }
    const handleReassign = (str) => {
        if (str === 'Cancel') {
            if (type === 'Apply') {
                handleCloseModal()
                setGetData([])
            }
            setType('Apply')
            setMatrixOptions(prevState => ({
                ...prevState,
                user: null,
                role: null
            }))
            setRemarks(null)
            return
        }
        if (type === 'Apply' && data.some(ele => ele.checkbox)) {
            setType('Reassign')
        }
        if (type === 'Reassign') {
            handleSubmit(onSubmit)()
        }
    }
    const [ remarks, setRemarks ] = useState(null)
    const onInputChange = (e) => {
        setRemarks(e)
    }
    return (
        <>
            <Dialog
                open={isOpened}
                sx={{ minHeight: '300px' }}
                PaperProps={{
                    style: { minHeight: '180px', minWidth: '600px' }
                }}
                key={'transfer-compliance'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '20px', flexGrow: 1, textAlign: 'center', color: 'hsl(var(--card))' }}>Reassign Compliance</div>
                    <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <CrossCircledIcon onClick={() => handleClose()} style={{ height: '22px', width: '22px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                    </Tooltip>
                </DialogTitle>
                <DialogContent className='!pt-[24px]' sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', alignItems: 'center', padding: '0px 24px 0px 24px', borderBottom: '2px solid hsl(var(--border))' }}>
                    {type === 'Reassign' && <ReRaci matrixOptions={matrixOptions} setMatrixOptions={setMatrixOptions} />}
                    {type === 'Apply' && <DateRange handleApply={handleDateApply} activeCalendarDate={activeCalendarDate} from={date.from} to={date.to} handleDateChange={handleDateChange}/>}
                    {type === 'Reassign' && <div className='w-full'>
                        <Textarea className={cn('ml-[0px]')} label="Remarks" value={remarks}
                            onValueChange={(e) => onInputChange(e)}
                            required
                            rules={{
                                validate: (value) => {
                                    if (!value) return t('This field is required')
                                    if (value.length > 251) return t('Character count should not exceed 250')
                                    return true
                                }
                            }}
                            defaultValue={remarks} type="text" placeholder="Enter Remarks" name="transfer" errors={errors} control={control} maxLength={250}/>
                    </div>
                    }
                    <ReassignTable selectAll={selectAll} handleSelectChecked={handleSelectChecked} data={getData} type={type}/>
                    {type !== 'Acknowledge' && <ApplyCancel handleSave={() => handleReassign('Reassign')} disable={((type === 'Reassign' && disable) || (type === 'Apply' && !getData?.some(ele => ele.checkbox)))} buttonName={type === 'Reassign' ? 'Reassign' : 'Apply'} handleCancel={() => handleReassign('Cancel')} />}
                    {type === 'Acknowledge' && <Acknowledge handleSave={() => handleAcknowledege() } />}
                </DialogContent>
            </Dialog>
        </>
    )
}
